<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Auto Focus'"
  [subTitle]="'Directives'"
>
  <div body>
    <app-modal #modal>
      <div *ngIf="!modal.isHidden">
        <input type="text" appAutoFocus />
      </div>
    </app-modal>
  </div>

  <div footer>
    <button (click)="modal.open()">Call Modal</button>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Debounce Click'"
  [subTitle]="'Directives'"
>
  <button
    body
    appCopy="Directive Copy Example"
    style="border: 1px solid black; text-align: center; padding: 19px"
  >
    Copy
  </button>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Scale Directive'"
  [subTitle]="'Directives'"
>
  <div
    body
    appScale
    style="
      width: 100px;
      height: 100px;
      background-color: #007acc;
      margin-left: auto;
      margin-right: auto;
    "
  ></div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Ripple'"
  [subTitle]="'Directives'"
>
  <div body>
    <button
      appRipple="ripple2"
      style="border: 1px solid black; text-align: center; padding: 10px"
    >
      Ripple Button
    </button>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Debounce Click'"
  [subTitle]="'Directives'"
>
  <div body>
    <button appDebounceClick (debounceClick)="log()">Log</button>
  </div>
</app-card>

<app-card
  [iconClasses]="'fas fa-info-circle'"
  [title]="'Lazy Load Image'"
  [subTitle]="'Directives'"
>
  <div body>
    <img
      width="100%"
      appLazyLoadImage
      src="https://images.unsplash.com/photo-1563364664-399838d1394c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1952&q=80"
      alt=""
    />
  </div>
</app-card>
